import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ContratoService, ProponenteService } from 'administrativo-lib';
import { ContratoRemanejo, ContratoRemanejoItem, EddyAutoComplete, Favorecido, FavorecidoService, FuncaoService, GlobalService, Licitacao, Login, Prazo, Proponente, TipoContratacao, TipoContrato } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';
import { ContratoItemService } from '../../contrato/service/contrato-item.service';
import { LicitacaoRemanejoService } from '../../licitacao-ocorrencia/service/licitacao-remanejo.service';
import { PrazoService, TipoContratacaoService } from 'compra-lib';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'lib-licitacao-remanejo-dlg',
  templateUrl: './licitacao-remanejo-dlg.component.html',
})
export class LicitacaoRemanejoDlgComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  protected datepipe: DatePipe;
  public ptBR: any;
  protected unsubscribe: Subject<void> = new Subject();
  public confirmSave = false;
  public proponenteAtual: ContratoRemanejo;
  public proponente: Proponente;
  public mostrarBtnIncluirProp: boolean = false;
  public desabilitarBotaoSalvar = false;
  public listaContratacao: TipoContratacao[];
  public listaPrazos: Prazo[];
  public listaTipos: { id: TipoContrato, nome: string }[];
  public tipos: { id: 'CONTRATO' | 'REGISTRO_PRECO' | 'ATA_REGISTRO', nome: string }[];

  public proponenteAutoComplete: EddyAutoComplete<Proponente>;
  public proponenteAuto: Proponente;
  public possuiContrato: any;

  @Input() visualizar_item: boolean;
  @Input() entidade: ContratoRemanejo;
  @Input() listaRemanejo: ContratoRemanejo[] = []
  @Input() lista: Array<any>;
  @Input() login: Login;
  @Input() licitacao: Licitacao;
  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();

  public imaskConfig = {
    mask: Number,
    scale: 4,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    public funcaoService: FuncaoService,
    public remanejoService: LicitacaoRemanejoService,
    private globalService: GlobalService,
    private contratoItemService: ContratoItemService,
    private contratoService: ContratoService,
    private confirmationService: ConfirmationService,
    protected contratacaoService: TipoContratacaoService,
    protected prazoService: PrazoService,
    private proponenteService: ProponenteService,
    private el: ElementRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['entidade'] && this.entidade?.id) {
      this.proponenteAtual = this.entidade;
    }
  }

  ngOnInit() {
    $('#dialogRemanejo').on('hidden.bs.modal', (e) => {
      this.proponenteAtual = null;
    });
    this.ptBR = this.globalService.obterDataBR();
    this.listaTipos = this.globalService.obterTiposContrato();
    this.tipos = [{ id: 'CONTRATO', nome: 'Contrato' }, { id: 'REGISTRO_PRECO', nome: 'Registro de Preço' }];

    this.contratacaoService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaContratacao = res ? res.content : [];
      }, error => toastr.error(error.message ? error.message : error));

    this.prazoService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaPrazos = res ? res.content : [];
      }, error => toastr.error(error.message ? error.message : error));

    this.proponenteAutoComplete = new EddyAutoComplete(null, this.proponenteService,
      'favorecido.id', ['favorecido.nome'], { 'licitacao.id': this.licitacao.id, relations: 'favorecido', orderBy: 'favorecido.nome' }, { number: ['favorecido.id', 'favorecido.cpf_cnpj'], text: ['favorecido.nome'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => this.globalService.calendarMascara(), 500);
  }

  public async salvar(): Promise<void> {
    try {
      let listaSalvar: ContratoRemanejo[] = [];
      this.desabilitarBotaoSalvar = true;
      for (const remanejo of this.listaRemanejo) {
        if (remanejo.itens.find(i => i.quantidade > 0)) {
          if (!remanejo.especie) {
            throw new Error(`Por favor, selecione a espécie do remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }
          if (!remanejo.data_remanejo) {
            throw new Error(`É necessário informar a data do remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }
          const inativo = this.isContratoInativo(remanejo);

          if (inativo) {
            remanejo.data_contabilizacao = null;
            remanejo['inativo'] = true;
          } else {
            remanejo['inativo'] = false;
          }

          if (!remanejo.data_contabilizacao && !inativo) {
            throw new Error(`Por favor, informe a data de contabilização do remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }
          if (!remanejo.motivo) {
            throw new Error(`Por favor, preencha o campo motivo para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }

          const itemSemValor = remanejo.itens.find(i => i.quantidade > 0 && (!i.valor_unitario || i.valor_unitario <= 0));
          if (itemSemValor) {
            throw new Error(`Por favor, informe um valor unitário maior que 0 para o item ${itemSemValor.contrato_item?.produto_unidade?.produto?.codigo || ''} no remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }

          if (remanejo.data_contabilizacao) {
            if (!this.funcaoService.podeAlterarAudesp(remanejo.data_contabilizacao, this.login)) {
              throw new Error(`Data de contabilização inválida para o remanejo de ${remanejo.proponente.favorecido.nome}. O período contábil já está fechado. Entre em contato com o contador.`);
            }

            const dtContabilizacao: Date = remanejo.data_contabilizacao;
            if (dtContabilizacao.getFullYear() !== this.login.exercicio.ano) {
              throw new Error(`O ano da data de contabilização do remanejo de ${remanejo.proponente.favorecido.nome} está diferente do exercício logado.`);
            }
          }

          if (remanejo['incluirContrato']) {
            if (!remanejo['numero']) {
              throw new Error(`Por favor, informe o número do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['tipo']) {
              throw new Error(`Por favor, selecione o tipo de contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['data_assinatura']) {
              throw new Error(`É necessário informar a data de assinatura do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['data_inicio']) {
              throw new Error(`É necessário informar a data de início do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['data_termino']) {
              throw new Error(`É necessário informar a data de término do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            remanejo['data_contabilizacao_contrato'] = remanejo.data_contabilizacao;
            if (!remanejo['tipo_contratacao']) {
              throw new Error(`Por favor, selecione o tipo de contratação para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['prazo']) {
              throw new Error(`Por favor, selecione o prazo de pagamento do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
          }
          remanejo.itens = remanejo.itens.filter(i => i.quantidade > 0);
          remanejo.valor_total = this.totalizar(remanejo.itens);
          this.calcularTotalLSM(remanejo);
          listaSalvar.push(remanejo);
        }
      }
      if (listaSalvar.length) {
        await this.remanejoService.salvarLista(listaSalvar).toPromise();
        toastr.success('Remanejo inserido com sucesso!');
        $('#dialogRemanejo').modal('hide');
        this.confirmSave = false;
      } else {
        throw new Error(`Não houve nenhum remanejo realizado para salvar.`);
      }

      this.visualizarChange.emit(true);
    } catch (e) {
      this.desabilitarBotaoSalvar = false;
      this.funcaoService.acaoErro(e);
      return;
    }
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

  public onFocusDate() {
    this.globalService.calendarMascara();
  }

  public isContratoInativo(remanejo: any): boolean {
    if (!remanejo) return false;
    if (this.entidade?.id) {
      return false;
    }
    if (remanejo['incluirContrato']) {
      return this.login.parametro['licitacao']?.contratos_inativos;
    }
    if (remanejo.contrato) {
      return remanejo.contrato.inativo;
    }
    return this.login.parametro['licitacao']?.contratos_inativos;
  }

  public calcularTotalLSM(remanejo: ContratoRemanejo): void {
    const totalMaterial = remanejo.itens.reduce((acc, cur) => {
      if (!cur.contrato_item?.produto_unidade?.produto?.material?.servico) {
        return acc + (cur.valor_unitario * cur.quantidade);
      }
      return acc;
    }, 0);
    remanejo.valor_material = this.funcaoService.arredondar(totalMaterial, 2);

    const totalServico = remanejo.itens.reduce((acc, cur) => {
      if (
        cur.contrato_item?.produto_unidade?.produto?.material?.servico &&
        !cur.contrato_item?.produto_unidade?.produto?.material?.locacao
      ) {
        return acc + (cur.valor_unitario * cur.quantidade);
      }
      return acc;
    }, 0);
    remanejo.valor_servico = this.funcaoService.arredondar(totalServico, 2);

    const totalLocacao = remanejo.itens.reduce((acc, cur) => {
      if (cur.contrato_item?.produto_unidade?.produto?.material?.locacao) {
        return acc + (cur.valor_unitario * cur.quantidade);
      }
      return acc;
    }, 0);
    remanejo.valor_locacao = this.funcaoService.arredondar(totalLocacao, 2);
  }

  public async carregarRemanejos() {
    if (!this.proponenteAtual) return;

    if (this.proponenteAtual.contrato && this.proponenteAtual.contrato.id) {
      // 1) Contrato já vinculado diretamente ao remanejo (via método adicionar())
      this.possuiContrato = this.proponenteAtual.contrato;
    } else {
      // 2) Buscar na lista em memória (contratos já carregados na licitação)
      const contratoEmMemoria = this.licitacao?.contratos?.find(c =>
        !c.excluido && c?.favorecido?.id === this.proponenteAtual.proponente.favorecido.id
      );

      if (contratoEmMemoria) {
        this.possuiContrato = contratoEmMemoria;
        // Vincular imediatamente ao remanejo para ser enviado ao backend
        this.proponenteAtual.contrato = contratoEmMemoria;
      } else {
        // 3) Buscar via API — sem filtro de inativo para encontrar contratos pendentes
        const resultado = await this.contratoService.filtrar(0, 0, {
          'licitacao.id': this.licitacao.id,
          'favorecido.id': this.proponenteAtual.proponente.favorecido.id,
          'orgao.id': this.login.orgao.id,
          excluido: false,
          relations: 'itens.memorial,itens.produto_unidade.produto',
        }).toPromise();

        if (resultado?.content?.length) {
          this.possuiContrato = resultado.content[0];
          // Vincular ao remanejo para ser enviado ao backend
          this.proponenteAtual.contrato = resultado.content[0];
        } else {
          this.possuiContrato = null;
        }
      }
    }

    this.proponenteAtual['incluirContrato'] = !this.possuiContrato?.id;

    if (this.proponenteAtual['incluirContrato']) {
      await this.carregarDadosContrato();
    }
    this.converterRemanejo();
  }

  private calcularQuantidadeDisponivel(itemDaEntidade: any): number {
    let quantidadeAtual = itemDaEntidade.quantidade;

    if (this.licitacao?.contratos?.length > 0) {
      this.licitacao.contratos.filter(c => !c.excluido).forEach(contrato => {
        if (contrato.itens?.length > 0) {
          const itensDoContrato = contrato.itens.filter(i => i.memorial?.id === itemDaEntidade.id || i.produto_unidade?.id === itemDaEntidade.produto_unidade?.id);
          itensDoContrato.forEach(itemContrato => {
            quantidadeAtual -= +(itemContrato.quantidade || 0);
          });
        }
      });
    }

    const pendentes = this.contratoService.obterContratosPendentesLicitacao(this.licitacao);
    if (pendentes?.length > 0) {
      pendentes.forEach(p => {
        const propostas = p.propostas?.filter(prop => prop.memorial?.id === itemDaEntidade.id || prop.memorial?.produto_unidade?.id === itemDaEntidade.produto_unidade?.id);
        propostas?.forEach(proposta => {
          let quantidadeContratada = 0;
          this.licitacao?.contratos?.filter(c => !c.excluido && c?.favorecido?.id === p?.favorecido?.id).forEach(c => {
            c?.itens?.filter(i => i?.memorial?.id === proposta?.memorial?.id || (i?.produto_unidade?.id && i?.produto_unidade?.id === proposta?.memorial?.produto_unidade?.id)).forEach(item => {
              quantidadeContratada += +(item.quantidade || 0);
            });
          });

          const pendenteReal = +(proposta.quantidade_final || 0) - quantidadeContratada;
          if (pendenteReal > 0) {
            quantidadeAtual -= pendenteReal;
          }
        });
      });
    }

    return quantidadeAtual;
  }

  public converterRemanejo() {
    this.proponenteAtual?.itens?.forEach((prop) => {
      const itemDaEntidade = this.licitacao?.itens?.find(i => i.id === prop.contrato_item?.id || i.id === prop.contrato_item?.memorial?.id || i.produto_unidade?.id === prop.contrato_item?.produto_unidade?.id);
      if (itemDaEntidade) {
        let quantidadeAtual = this.calcularQuantidadeDisponivel(itemDaEntidade);

        if (this.lista?.length > 0) {
          this.lista.forEach(historico => {
            if (this.proponenteAtual?.id && historico.id === this.proponenteAtual.id) {
              return;
            }
            if (historico.contrato && this.licitacao?.contratos?.find(c => c.id === historico.contrato.id && !c.excluido)) {
              return; // Já subtraído no calcularQuantidadeDisponivel
            }
            const quantidadeJaSalva = historico?.itens?.reduce((acc, atual) => {
              if (atual.contrato_item?.id === itemDaEntidade.id || atual.memorial?.id === itemDaEntidade.id || atual.contrato_item?.memorial?.id === itemDaEntidade.id || atual.contrato_item?.produto_unidade?.id === itemDaEntidade.produto_unidade?.id) {
                return acc + (+atual.quantidade);
              }
              return acc;
            }, 0);
            if (quantidadeJaSalva > 0) {
              quantidadeAtual -= quantidadeJaSalva;
            }
          });
        }

        if (!this.entidade?.id) {
          this.listaRemanejo.forEach(remanejo => {
            const quantidadeRemanejada = remanejo?.itens?.reduce((acc, atual) => {
              if (atual.contrato_item?.id === itemDaEntidade.id || atual.contrato_item?.memorial?.id === itemDaEntidade.id || atual.contrato_item?.produto_unidade?.id === itemDaEntidade.produto_unidade?.id) {
                return acc + (+atual.quantidade);
              }
              return acc;
            }, 0);

            if (quantidadeRemanejada > 0) {
              quantidadeAtual -= quantidadeRemanejada;
            }
          });
        }

        prop.saldo = prop.quantidade ? (quantidadeAtual + (+prop.quantidade)) : quantidadeAtual;
      }
    });
  }

  public totalizar(itens: ContratoRemanejoItem[]) {
    return this.funcaoService.arredondar(itens.reduce((acumulador, item) => (item.quantidade * item.valor_unitario) + acumulador, 0), 4);
  }

  public validarCamposRemanejo(item: ContratoRemanejoItem) {
    if (item.quantidade < 0) {
      toastr.error(`Por favor, informe a quantidade para o item: ${item?.contrato_item?.descricao}.`);
      this.carregarRemanejos();
    }
    if (item.quantidade > item.saldo) {
      toastr.error(`A quantidade informada para o item ${item?.contrato_item?.descricao} é maior do que a disponível no histórico.`);
      item.quantidade = 0;
      this.carregarRemanejos();
    }
    const itemDoContrato = this.licitacao?.itens?.find(i => i.id === item.contrato_item?.id || i.id === item.contrato_item?.memorial?.id || i.produto_unidade?.id === item.contrato_item?.produto_unidade?.id);

    if (itemDoContrato) {
      let quantidadeRemanejada = 0;

      if (!this.entidade?.id) {
        this.listaRemanejo.forEach(remanejo => {
          const somaRemanejo = remanejo?.itens?.reduce((acc, atual) => {
            if (atual.contrato_item?.id === itemDoContrato.id || atual.contrato_item?.memorial?.id === itemDoContrato.id || atual.contrato_item?.produto_unidade?.id === itemDoContrato.produto_unidade?.id) {
              return acc + (+atual.quantidade);
            }
            return acc;
          }, 0);
          quantidadeRemanejada += somaRemanejo || 0;
        });
      } else {
        const somaAtual = this.proponenteAtual?.itens?.reduce((acc, atual) => {
          if (atual.contrato_item?.id === itemDoContrato.id || atual.contrato_item?.memorial?.id === itemDoContrato.id || atual.contrato_item?.produto_unidade?.id === itemDoContrato.produto_unidade?.id) {
            return acc + (+atual.quantidade);
          }
          return acc;
        }, 0);
        quantidadeRemanejada += somaAtual || 0;
      }

      if (this.lista?.length > 0) {
        this.lista.forEach(historico => {
          if (this.proponenteAtual?.id && historico.id === this.proponenteAtual.id) {
            return;
          }
          if (historico.contrato && this.licitacao?.contratos?.find(c => c.id === historico.contrato.id && !c.excluido)) {
            return; // Já contabilizado no saldoPrevisto
          }
          const somaHistorico = historico?.itens?.reduce((acc, atual) => {
            if (atual.contrato_item?.id === itemDoContrato.id || atual.memorial?.id === itemDoContrato.id || atual.contrato_item?.memorial?.id === itemDoContrato.id || atual.contrato_item?.produto_unidade?.id === itemDoContrato.produto_unidade?.id) {
              return acc + (+atual.quantidade);
            }
            return acc;
          }, 0);
          quantidadeRemanejada += somaHistorico || 0;
        });
      }

      const saldoPrevisto = this.calcularQuantidadeDisponivel(itemDoContrato);
      if (quantidadeRemanejada > saldoPrevisto) {
        toastr.error(`A quantidade informada para o item é maior do que a prevista no item.`);
        item.quantidade = 0;
        this.carregarRemanejos();
      }
    }
  }

  public adicionar() {
    this.mostrarBtnIncluirProp = true;
    this.proponente = new Proponente();
    this.proponente.favorecido = new Favorecido();
    this.proponente.situacao = 'HABILITADO';

    const modal = $(this.el.nativeElement).find('#dialogFavorecidoCadastro');
    if (modal.length > 0) {
      modal.modal('show');
      setTimeout(() => {
        modal.css('z-index', 1060);
        $('.modal-backdrop').last().css('z-index', 1055);
      }, 150);
    } else {
      $('#dialogFavorecidoCadastro').modal('show');
    }
  }

  public salvarProponente(item: Proponente) {
    if (!this.mostrarBtnIncluirProp) return;
    if (!item) return;

    if (+item.favorecido.tipo.tce !== 1 && +item.favorecido.tipo.tce !== 2 && +item.favorecido.tipo.tce !== 3) {
      toastr.warning('Verifique a espécie no cadastro de fornecedor');
      return;
    }

    const pendentes = this.contratoService.obterContratosPendentesLicitacao(this.licitacao);
    const pendenteEncontrado = pendentes?.find(p => p.favorecido?.cpf_cnpj === item.favorecido.cpf_cnpj);
    if (pendenteEncontrado) {
      item = pendenteEncontrado;
    } else {
      const propExistente = this.licitacao?.proponentes?.find(p => p.favorecido?.cpf_cnpj === item.favorecido.cpf_cnpj);
      if (propExistente) {
        item = propExistente;
      }
    }

    this.atualizarOrdem();

    const itm = this.listaRemanejo.find((i) => i.proponente.favorecido.cpf_cnpj === item.favorecido.cpf_cnpj);
    if (itm) {
      itm.proponente.favorecido = item.favorecido;
      itm.proponente.epp_me = item.epp_me;
      itm.proponente.situacao = item.situacao;
      itm.proponente.motivo = item.motivo;
      this.proponenteAtual = itm;
    } else {
      if (this.listaRemanejo.length === 0) {
        item.ordem = 1;
      } else {
        item.ordem = (this.listaRemanejo.sort((a, b) => a.proponente.ordem - b.proponente.ordem)[this.listaRemanejo.length - 1].proponente.ordem) + 1;
      }
      let remanejoNovo = new ContratoRemanejo();
      remanejoNovo.data_remanejo = this.funcaoService.obterDataUTC(new Date());
      remanejoNovo.data_contabilizacao = this.funcaoService.obterDataUTC(new Date());
      remanejoNovo.licitacao = this.licitacao;
      remanejoNovo.usuario = this.login.usuario;
      remanejoNovo.exercicio = this.login.exercicio;
      remanejoNovo.proponente = item;
      remanejoNovo.especie = 'R';
      remanejoNovo.editavel = true;
      remanejoNovo.valor_total = 0;
      remanejoNovo.itens = [];
      for (const licitacaoItem of this.licitacao.itens) {
        remanejoNovo.itens.push({
          quantidade: 0,
          saldo: licitacaoItem['saldo_qtd'] !== undefined ? licitacaoItem['saldo_qtd'] : licitacaoItem.quantidade,
          valor_unitario: 0,
          contrato_item: licitacaoItem
        });
      }
      this.listaRemanejo.push(remanejoNovo);
      this.proponenteAtual = this.listaRemanejo[this.listaRemanejo.length - 1];
    }
    this.carregarRemanejos();
    this.proponente = undefined;
  }

  private atualizarOrdem() {
    if (!this.mostrarBtnIncluirProp) return;
    let ordem = 0;
    this.listaRemanejo.forEach((m) => {
      m.proponente.ordem = ++ordem;
    });
  }

  public async carregarDadosContrato() {
    if (!this.proponenteAtual['incluirContrato']) return;

    this.proponenteAtual['ano'] = new Date().getFullYear();
    this.proponenteAtual['modalidade'] = this.licitacao.modalidade;
    this.proponenteAtual['tipo_contratacao'] = this.licitacao.tipo_contratacao;
    this.proponenteAtual['objeto'] = this.licitacao.objeto;
    this.proponenteAtual['processo'] = this.licitacao.processo;
    this.proponenteAtual['orgao'] = this.login.orgao;
    this.proponenteAtual['inativo'] = this.login.parametro['licitacao']?.contratos_inativos;
    this.proponenteAtual['data_assinatura'] = this.licitacao.data_assinatura || null;
    this.proponenteAtual['data_inicio'] = this.licitacao.data_inicio || null;
    this.proponenteAtual['data_termino'] = this.licitacao.data_termino || null;
    this.proponenteAtual['prazo'] = this.licitacao.prazo_pagamento || null;
    this.proponenteAtual['entrega'] = this.licitacao.prazo_entrega || null;

    this.proponenteAtual['numero'] = await this.contratoService.proximoNumero(this.login.exercicio.ano, this.login.orgao.id).toPromise();
    this.proponenteAtual['tipo'] = this.licitacao?.formato_contratacao === 'REGISTRO_PRECO' ? 'REGISTRO_PRECO' : 'CONTRATO';
  }

  selecionarProponente(proponenteSelecionado: Proponente) {
    if (!proponenteSelecionado) return;

    const existente = this.listaRemanejo.find(r => r.proponente?.favorecido?.id === proponenteSelecionado.favorecido?.id);
    if (existente) {
      this.proponenteAtual = existente;
      this.carregarRemanejos();
      this.proponenteAuto = null;
      return;
    }

    this.proponenteAtual = {
      data_remanejo: this.funcaoService.obterDataUTC(new Date()),
      data_contabilizacao: this.funcaoService.obterDataUTC(new Date()),
      licitacao: this.licitacao,
      usuario: this.login.usuario,
      exercicio: this.login.exercicio,
      proponente: proponenteSelecionado,
      editavel: true,
      especie: 'R',
      valor_total: 0,
      itens: this.licitacao.itens.map(item => ({
        quantidade: 0,
        saldo: item['saldo_qtd'] !== undefined ? item['saldo_qtd'] : item.quantidade,
        valor_unitario: 0,
        contrato_item: item
      }))
    };

    this.listaRemanejo.push(this.proponenteAtual);
    this.carregarRemanejos();
    this.proponenteAuto = null;
  }
}
